export const BrandLogo = ({ emblemClass = "h-9", textClass = "text-[0.6rem]", testid = "brand-logo" }) => (
  <span className="brand-logo">
    <img src="/arij-emblem.png" alt="" aria-hidden="true" className={`brand-logo-emblem ${emblemClass}`} data-testid={testid} draggable="false" />
    <span className={`brand-logo-text ${textClass}`}>ARIJ&nbsp;MISK</span>
  </span>
);
